import axios from "axios";

export default {
	auditQuery(query, ctx) {
		let body = _.extend(query, ctx);
		return axios.post("/v3/audit", body);
	},

	scoreAuditQuery(query, ctx) {
		let body = _.extend(query, ctx);
		return axios.post("/v3/audit/scores", body);
	},

	markReliability(selection) {
		return axios.post("/v3/batch/responses/reliability", selection);
	},

	// setResponsePriority(selection, priority) {
	// 	let request = {
	// 		selection: selection,
	// 		priority: priority
	// 	};
	// 	return axios.post("/v3/batch/responses/priority", request);
	// },

	deleteResponses(selection) {
		return axios.post("/v3/batch/responses/delete", selection);
	},

	resetResponses(selection) {
		return axios.post("/v3/batch/responses/reset", selection);
	},

	resetScores(selection) {
		return axios.post("/v3/batch/scores/reset", selection);
	}
};



// WEBPACK FOOTER //
// ./src/services/AuditingService.js